import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";
import api from "./Api.js";
import "./Login.css";

const Login = () => {
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      navigate("/messages");
    }
  }, [navigate]);

  const validateForm = () => {
    const newErrors = {};
    if (!userName) newErrors.username = "Username is required";
    if (!password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      const response = await api.post("/api/admin/Admin/Login", {
        userName,
        PasswordHash: password,
      });

      const data = response.data;

      if (data.accessToken) {
        localStorage.setItem("accessToken", data.accessToken);
        navigate("/messages");
      } else {
        setErrors({ submit: "Login failed: no access token returned." });
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          setErrors({ submit: "Invalid username or password" });
        } else if (error.response.status === 403) {
          setErrors({ submit: "Account is disabled" });
        } else {
          setErrors({ submit: "Login failed. Please try again." });
        }
      } else {
        setErrors({
          submit: error.message || "An error occurred. Please try again.",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        {/* Welcome side */}
        <div className="login-welcome">
          <div className="welcome-header">
            <h1>Spark Media Admin</h1>
            <p>Integrated platform to manage billboards & bookings</p>
          </div>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <div className="feature-text">
                <h3>Billboard Management</h3>
                <p>Add, edit and remove billboards easily</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">📅</span>
              <div className="feature-text">
                <h3>Booking Tracking</h3>
                <p>Monitor booking dates and availability</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">📱</span>
              <div className="feature-text">
                <h3>Responsive UI</h3>
                <p>Work on any device with a great experience</p>
              </div>
            </div>
          </div>

          <div className="login-footer">
            <p>
              Contact Support: <strong>support@sparkmedia.com</strong>
            </p>
          </div>
        </div>
        {/* Form side */}
        <div className="login-form-container">
          <div className="form-header">
            <h2>Sign In</h2>
            <p>Enter your credentials to access the admin panel</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group floating">
              <FaUser className="input-icon" />
              <input
                type="text"
                id="username"
                value={userName}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder=" "
                className={errors.username ? "error" : ""}
              />
              <label htmlFor="username">Username</label>
            </div>
            {errors.username && (
              <span className="error-message">{errors.username}</span>
            )}

            <div className="form-group floating">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder=" "
                className={errors.password ? "error" : ""}
              />
              <label htmlFor="password">Password</label>
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}

            {errors.submit && (
              <div className="error-message submit-error">
                <span>⚠️</span>
                {errors.submit}
              </div>
            )}

            <button type="submit" className="login-btn" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Signing in...
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>{" "}
      </div>
    </div>
  );
};

export default Login;
